import React from "react";

import frame5 from "../../../image/event-triggered.webp";
import frame6 from "../../../image/purchase-based-insights.webp";

const UniqueFeature = () => {
  const features = [
    {
      img: frame5,
      title: "Event-Triggered Campaigns",
      text: "Set up custom triggers for recurring events or user actions, keeping your communication timely and relevant.",
    },
    {
      img: frame6,
      title: "Purchase-Based Insights",
      text: "Integrate purchase data to provide personalized recommendations and exclusive offers for each subscriber.",
    },
  ];
  return (
    <>
      <h2 className="lp-product-heading">Unique Features</h2>

      <h2 className="lp-heading">Innovative Highlights</h2>

      <p className="lp-heading-desc">
        Revolutionize your newsletters with AI-powered tools for timing <br />
        content, and engagement optimization.
      </p>

      <div className="lp-container">
        <div className="lp-product-section">
          {features.map((feature, index) => (
            <div
              key={index}
              className="lp-product-card card4"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              <img
                src={feature.img}
                alt={feature.title}
                className="lp-card-img"
              />
              <h3>{feature.title}</h3>
              <p className="lp-text">{feature.text}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default UniqueFeature;
